import { render } from "./Home.vue?vue&type=template&id=d15cd146"
const script = {}
script.render = render

export default script